import {GenApiKey} from '../../generated/serverModels/GenApiKey';

export class ApiKey extends GenApiKey {
  constructor(apiKey?: Partial<ApiKey>) {
    super(apiKey);
  }
}
